Namespace 'Monitoring.Reports.Publications.Subsections'

class Monitoring.Reports.Publications.Subsections.ComplaintsView extends Backbone.View

  template: JST['backbone/templates/monitoring/reports/publications/content/subsections/complaints']

  initialize: (@options = {}, @header, @model) ->
    @model.bind('complaintsFetched', @fill)
    # just set @options

  render: ->
    @$el.html(@template(@options))
    renderTo = 'complaints-container'
    return this

  fill: (complaints) =>
    data = complaints.getPrintableData()
    bar_chart_view = new Monitoring.Views.Charts.CountBarsChartView(data, "Complaints")
    @$('#complaints-container').append(bar_chart_view.el)
